const locale: Locale = {
  ko: {
    email: '지스트 이메일을 입력하세요',
  },
  en: {
    email: 'GIST email',
  },
}

export default locale
